const { getDateInstance } = require('./getDateInstance')

/**
 * Visszaadja a dátumból az évet.
 * @param {string | number | Date} tmp - A megadott dátum.
 * @example
 * ```js
 * getYear(new Date('2021-01-01')) // 2021
 * getYear('2024-03-03') // 2024
 * ```
 * @returns {number} Az adott dátum éve.
 */
module.exports.getYear = function getYear (tmp) {
  const date = getDateInstance(tmp)

  return date.getFullYear()
}
